import LdSlideOutMixins from './components/LdSlideOut/mixins';

export default {
  LdSlideOutMixins,
};
